import React from "react";
const Calendar = ({ color, ...props }: any) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.833 0c.46 0 .834.373.834.833v.834h6.666V.833a.833.833 0 1 1 1.667 0v.834h.833A3.333 3.333 0 0 1 19.167 5v10.833a3.333 3.333 0 0 1-3.334 3.334H4.167a3.333 3.333 0 0 1-3.334-3.334V5a3.333 3.333 0 0 1 3.334-3.333H5V.833C5 .373 5.373 0 5.833 0ZM4.167 3.333C3.247 3.333 2.5 4.08 2.5 5v.833h15V5c0-.92-.746-1.667-1.667-1.667H4.167ZM17.5 7.5h-15v8.333c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V7.5ZM5.417 10.833c0-.46.373-.833.833-.833h1.667a.833.833 0 0 1 0 1.667H6.25a.833.833 0 0 1-.833-.834Zm5.833 0c0-.46.373-.833.833-.833h1.667a.833.833 0 0 1 0 1.667h-1.667a.833.833 0 0 1-.833-.834Zm-5.833 3.334c0-.46.373-.834.833-.834h1.667a.833.833 0 0 1 0 1.667H6.25a.833.833 0 0 1-.833-.833Zm5.833 0c0-.46.373-.834.833-.834h1.667a.833.833 0 0 1 0 1.667h-1.667a.833.833 0 0 1-.833-.833Z"
      fill={color || "currentColor"}
    />
  </svg>
);

export default Calendar;
